import { Colors, Shadows } from 'cio-design-library/design-tokens'
import styled from 'styled-components'

export const ZoomControlsContainer = styled.div`
  position: fixed;
  bottom: 32px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  height: 48px;
  border-radius: 24px;
  background-color: ${Colors.White};
  box-shadow: ${Shadows.lightWithBorderShadowMid};
`

export const ZoomControlButton = styled.button`
  border: none;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 48px;
  min-width: 48px;
  color: ${Colors.Neutral70};
  user-select: none;

  &:disabled {
    color: ${Colors.Neutral30};
    pointer-events: none;
  }
`

export const CurrentZoomLevel = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex: auto;
  min-width: 60px; // used to fix bug on iOS Safari
  border-left: 0.5px solid ${Colors.Neutral15};
  border-right: 0.5px solid ${Colors.Neutral15};
  color: ${Colors.Neutral80};
`
